import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { MaskLine, FadeUp } from "./Reveal";
import { SERVICES } from "../constants/services";

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-28 md:py-40 bg-[#F3EFE6] hairline-t">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <div className="mb-16 md:mb-24">
        <FadeUp>
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#B89B67] font-semibold mb-10">What We Do</p>
        </FadeUp>
        <h2 className="font-display font-light text-[#1A3626] text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
          <MaskLine delay={0.1}>Services</MaskLine>
        </h2>
        <FadeUp delay={0.3} className="mt-8 max-w-[52ch]">
          <p className="text-sm md:text-base leading-relaxed text-[#2C2926]/70">
            From site clearing and vineyard development to farming, pest management, labor, harvest and fruit sales, every program is tailored to your vineyard, your goals and its long-term sustainability.
          </p>
        </FadeUp>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-[#E5DEC9] border border-[#E5DEC9]">
        {SERVICES.map((service, i) => (
          <FadeUp key={service.slug} delay={(i % 2) * 0.08} y={24}>
            <Link
              to={`/services/${service.slug}`}
              data-testid={`service-card-${i + 1}`}
              className="group block w-full text-left bg-[#F3EFE6] hover:bg-[#F9F6F0] transition-colors duration-500 p-10 md:p-14 h-full"
            >
              <div className="flex justify-end">
                <ArrowUpRight size={18} className="text-[#364132]/40 transition-all duration-500 group-hover:text-[#B89B67] group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <h3 className="font-display font-light text-2xl md:text-[2rem] text-[#1A3626] mt-8 mb-4 leading-tight">{service.title}</h3>
              <p className="text-sm leading-relaxed text-[#2C2926]/70 max-w-[46ch]">{service.summary}</p>
            </Link>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
